<template>
  <button
    :type="'' ? 'button' : tipo"
    class="btn"
    :class="estiloBotao"
    :data-toggle="toggle"
    :data-target="target"
    :data-dismiss="dismiss"
    :disabled="disabled"
    @click="dispara()"
  >
    <i class="fa" :class="iconeBotao" v-show="!iconeDireita"></i>
    {{ rotulo }}
    <i class="fa" :class="iconeBotao" v-show="iconeDireita"></i>
  </button>
</template>

<script>
export default {
  data() {
    return {
      iconeData: this.icone,
    };
  },
  props: {
    tipo: {
      required: false,
      default: "button",
      type: String,
    },
    estilo: {
      required: true,
      type: String,
    },
    rotulo: {
      required: false,
      default: "",
      type: String,
    },
    icone: {
      required: false,
      default: "",
      type: String,
    },
    toggle: {
      required: false,
      default: "",
      type: String,
    },
    target: {
      required: false,
      default: "",
      type: String,
    },
    dismiss: {
      required: false,
      default: "",
      type: String,
    },
    iconeDireita: {
      required: false,
      default: false,
      type: Boolean,
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  methods: {
    dispara() {
      if (this.disabled) return;
      this.iconeData = "carregando";
      setTimeout(() => {
        this.iconeData = this.icone;
      }, 1000);
      this.$emit("clicado");
      document.querySelector(".btn").blur();
    },
  },
  computed: {
    estiloBotao() {
      if (this.estilo == "vazado-verde") return "btn-primary";
      if (this.estilo == "cheio-verde") return "btn-primary side-btn-primary";
      if (this.estilo == "vazado-cinza") return "btn-default";
      if (this.estilo == "cheio-cinza") return "btn-default side-btn-default";
      if (this.estilo == "vazado-verde-dir") return "btn-primary btn-next";
      if (this.estilo == "cheio-verde-dir")
        return "btn-primary side-btn-primary btn-next";
      if (this.estilo == "vazado-cinza-dir") return "btn-default btn-next";
      if (this.estilo == "vazado-verde-esq") return "btn-primary btn-previous";
      if (this.estilo == "vazado-cinza-esq") return "btn-default btn-previous";
      if (this.estilo == "cheio-cinza-esq")
        return "btn-default side-btn-default btn-previous";
      if (this.estilo == "cheio-verde-esq")
        return "btn-primary side-btn-primary btn-previous";
      if (this.estilo == "vazado-laranja-esq")
        return "btn-warning btn-previous";
      if (this.estilo == "vazado-verde-sm") return "btn-primary btn-sm";
      if (this.estilo == "vazado-cinza-sm") return "btn-default btn-sm";
      if (this.estilo == "vazado-laranja-sm") return "btn-warning btn-sm";
      if (this.estilo == "vazado-vermelho-sm") return "btn-danger btn-sm";
      if (this.estilo == "vazado-verde-lg")
        return "btn-primary btn-subscribe btn-lg";
      if (this.estilo == "cheio-verde-lg")
        return "btn-primary side-btn-primary btn-subscribe btn-lg";
      if (this.estilo == "vazado-verde-inline") return "btn-primary btn-inline";
      else return "btn-primary";
    },

    iconeBotao() {
      if (this.iconeData == "ok-modal") return "fa-check";
      if (this.iconeData == "cancela-modal") return "fa-ban";
      if (this.iconeData == "novo-modal") return "fa-file-o";
      if (this.iconeData == "mais") return "fa-plus";
      if (this.iconeData == "salvar") return "fa-floppy-o";
      if (this.iconeData == "apagar") return "fa-eraser";
      if (this.iconeData == "exclui-tabela") return "fa-trash fa-lg";
      if (this.iconeData == "editar-tabela") return "fa-pencil fa-lg";
      if (this.iconeData == "imprimir-tabela") return "fa fa-print fa-lg";
      if (this.iconeData == "voltar") return "fa-caret-left fa-lg";
      if (this.iconeData == "avancar") return "fa-caret-right fa-lg";
      if (this.iconeData == "buscar") return "fa-search";
      if (this.iconeData == "visualizar") return "fa-eye fa-lg";
      if (this.iconeData == "carregando") return "fa-spinner fa-pulse";
      else return this.iconeData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?7e81d7fc